import { IBaseService } from '../../services/misc/base.service';

export interface IErrorService extends IBaseService {

    handleErrorAsync(error: any, showDialog?: boolean): Promise<void>;
    //parseError(error: any): string[];
    showErrorAsync(error: any): Promise<void>;

}
